import React, { useEffect, useState } from "react";
import "./Cancel_order.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowLeft,
  faCircleChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import Order_details_table from "../order_details/order_details_table/Order_details_table";
import Select_reason_heading from "../../../../../Common-Component/select_reason_heading/Select_reason_heading";
import Reason_cancelling_field_holder from "../../../../../Common-Component/reason_cancelling_field_holder/Reason_cancelling_field_holder";
import Common_Back_Header from "../../../../../Common-Component/common_back_header/Common_Back_Header";
import { getallCancelationReason } from "../../../../../../utils/apis/master/Master";
import { singleOrderGet } from "../../../../../../utils/apis/myAccount/myAccount";
import { formatCustomDate } from "../../../../../../utils/common";
import { postCancelOrder } from "../../../../../../utils/apis/orderProcess/orderProcess";
import Success_Modal_2 from "../../../../../Common_modal/success_modal2/Success_Modal_2";

function Cancel_order() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "ORDER DETAILS", link: `/order-details`, isActive: false },
    { label: "CANCEL ORDER", link: "", isActive: true },
  ];

  const { id } = useParams();
  const [reason, setReason] = useState([]);

  const GetReason = async () => {
    const res = await getallCancelationReason();
    if (res?.success) {
      setReason(res?.data);
    }
  };

  useEffect(() => {
    GetReason();
  }, []);

  const [order, setOrder] = useState([]);
  const fetchOrder = async (id) => {
    const res = await singleOrderGet(id);
    if (res?.success) {
      setOrder(res.data);
    }
  };
  useEffect(() => {
    fetchOrder(id);
  }, [id]);

  const [selectedReason, setSelectedReason] = useState("");
  const [ReasonId, setReasonId] = useState(null);

  const [Remark, setRemark] = useState(null);
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const navigate = useNavigate();
  const onSubmit = async () => {
    const data = {
      remark: Remark,
      order_id: order?.id,
      cancel_reason_id: ReasonId,
    };

    const res = await postCancelOrder(data);
    if (res?.success) {
      setShowSucsessModal(true);

      setTimeout(() => {
        setShowSucsessModal(false);
        navigate(`/order-details/${order?.id}`);
      }, 3000);
    }
  };
  return (
    <>
      <section className="Cancel_order">
        <div className=" cancel_order_holder">
          <div className="container">
            <div className="title_holder">
              <div className="heading_holder">
                <h4>
                  <Link to={`/order-details/${id}`}>
                    <FontAwesomeIcon
                      className=" arrow_icon me-sm-3 me-2"
                      icon={faCircleChevronLeft}
                    />
                  </Link>{" "}
                  Cancel Order
                </h4>
              </div>

              <div className="text_holder">
                <h6>Order ID #{order?.invoice_number}</h6>
                <h5>{formatCustomDate(order?.createdAt)}</h5>
              </div>
            </div>

            <Order_details_table order={order} />

            <Select_reason_heading
              text={"cancelation"}
              reason={reason}
              setReasonId={setReasonId}
              ReasonId={ReasonId}
              setSelectedReason={setSelectedReason}
              selectedReason={selectedReason}
            />

            <Reason_cancelling_field_holder
              text={"cancelling"}
              navigate={navigate}
              showSuccessModal={showSuccessModal}
              setShowSucsessModal={setShowSucsessModal}
              onSubmit={onSubmit}
              order={order}
              Remark={Remark}
              setRemark={setRemark}
              selectedReason={selectedReason}
              ReasonId={ReasonId}
            />
          </div>
        </div>

        <Success_Modal_2
          successText="Order Cancelled Successfully!"
          show={showSuccessModal}
          onHide={() => setShowSucsessModal(false)}
        />
      </section>
    </>
  );
}

export default Cancel_order;
